<template>
  <div class="sentence-body" style="background-color: #ffffff">
    <div class="left-step"></div>
    <div style="flex:1">
      <div class="accordion-header">
        <div style="flex:1">
          <div class="step-down"></div>
          <label>源语句：</label>
        </div>
        <!--        <div>-->
        <!--          <template v-if="coreWords.length">-->
        <!--            核心词：-->
        <!--            <span class="tag" v-for="(item, index) in coreWords" :key="index">{{-->
        <!--              item-->
        <!--            }}</span>-->
        <!--          </template>-->
        <!--        </div>-->
      </div>
      <div class="lspan">
        <span>{{ sentence }} </span>
      </div>
      <div
        class="sentence-body-part"
        style="background-color:white;display:flex"
      >
        <div style="flex:1">
          <!--          核心词是否替换-->
          <!--          <el-switch class="switch_top" :width="33" v-model="replace">-->
          <!--          </el-switch>-->
        </div>
        <div>
          显示修改对比
          <span
            style=" background-color: #fbddda;text-decoration: line-through;"
            >AB</span
          >
          <span style="background-color: #d0e4c9;text-decoration: underline;"
            >BC</span
          >
          <el-switch class="switch_top" :width="33" v-model="showTxtType">
          </el-switch>
        </div>
      </div>
      <div class="accordion-header">
        <div class="step-down" v-if="showMiddle"></div>
        <label>智能改写</label>
        <span style="color: #999;"
          >（说明：分别选择下面的改写风格，可得到不同的改写结果）</span
        >
        <div class="line"></div>
        <el-switch
          v-if="false"
          class="switch_top"
          :width="33"
          v-model="showMiddle"
          style="margin-right: 5px;"
        >
        </el-switch>
      </div>
      <div class="sentenceMain">
        <div class="sentence-body-part" v-if="showMiddle">
          <div
            v-loading="item.loading"
            class="group"
            v-for="(item, index) in middleList"
            :key="index"
          >
            <div>
              <div class="tabs-box">
                <div style="flex: 1">
                  <ul class="tabs">
                    <li
                      style="border:1px solid rgb(195, 201, 210);border-bottom:none"
                    >
                      {{
                        index === 0
                          ? "文风流畅改写"
                          : index === 1
                          ? "谨慎句式改写"
                          : index === 2
                          ? "轻度句式改写"
                          : "轻度句式改写"
                      }}
                    </li>
                  </ul>
                </div>

                <div>
                  <button
                    class="btn"
                    @click="use(item.result)"
                    style="right:0;bottom:5px;padding:0 .5em"
                  >
                    替換原文
                  </button>
                </div>
              </div>
              <textarea
                class="input"
                v-model="item.result"
                v-if="!showTxtType"
                style="border:1px solid rgb(195, 201, 210)"
              ></textarea>
              <div
                class="input input-div"
                v-else
                style="border:1px solid rgb(195, 201, 210)"
              >
                <div v-html="item.html" style="padding-bottom:20px;"></div>
              </div>
            </div>
            <div class="similar">
              相似度<span>{{ item.like == "100.00" ? "100" : item.like }}</span
              >%
            </div>
            <!--          <div style="color:red">{{ item.message }}</div>-->
          </div>
        </div>
        <div class="accordion-header" v-show="false">
          <div class="step-down"></div>
          <label>内容指纹重构</label>
          <div class="line"></div>
        </div>
        <div class="sentence-body-part" v-show="false" v-if="showMiddle">
          <div
            class="group"
            v-loading="item.loading"
            v-for="(item, index) in normalizedList"
            :key="index"
          >
            <div>
              <div class="tabs-box">
                <div style="flex: 1">
                  <ul class="tabs">
                    <li>指纹重构{{ index + 1 }}</li>
                  </ul>
                </div>
                <div>
                  <button
                    class="btn"
                    @click="getNormalized(index + 1, item.result)"
                    style="right:0;bottom:5px;padding:0 .5em;background-color: #fff;color: #3cb034;border-color: #3cb034;"
                  >
                    重新生成
                  </button>
                  <button class="btn" @click="use(item.result)">
                    替換原文
                  </button>
                </div>
                <!--              <div style="color:red">{{ item.message }}</div>-->
              </div>
              <textarea
                class="input"
                v-model="item.result"
                v-if="!showTxtType"
              ></textarea>
              <div
                class="input input-div"
                v-else
                style="border:1px solid rgb(195, 201, 210)"
              >
                <div v-html="item.html" style="padding-bottom:20px"></div>
              </div>
            </div>
            <div class="similar">
              相似度<span>{{ item.like == "100.00" ? "100" : item.like }}</span
              >%
            </div>
          </div>
        </div>
        <div class="sentence-body-part" style="margin:0" v-else>
          <div v-loading="fingerprint.loading" class="group group-flex">
            <div style="flex:1">
              <div class="tabs-box">
                <div style="flex: 1">
                  <ul class="tabs">
                    <li>结果</li>
                  </ul>
                  <!--                <div style="color:red">{{ fingerprint.message }}</div>-->
                </div>
                <div>
                  <button class="btn" @click="use(fingerprint.result)">
                    替換原文
                  </button>
                </div>
              </div>
              <textarea
                class="input"
                v-model="fingerprint.result"
                v-if="!showTxtType"
                readonly
              ></textarea>
              <div class="input input-div" v-else>
                <div
                  v-html="fingerprint.html"
                  style="padding-bottom:20px"
                ></div>
              </div>
              <div class="similar">
                相似度<span>{{
                  fingerprint.like == "100.00" ? "100" : fingerprint.like
                }}</span
                >%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SendPostData,
  SentenceViewModel
} from "../../assets/script/model/index";
import tinymce from "tinymce";
import { mapActions } from "vuex";
export default {
  name: "GetSentence",
  data() {
    return {
      coreWords: [],
      topNumber: 100,
      sentence: "",
      replace: !localStorage.getItem("sentenceCoreWordsReplace"),
      showTxtType: !localStorage.getItem("sentenceCloseTxtType"),
      showMiddle: true /*!localStorage.getItem("sentenceShowMiddle")*/,
      middleList: [
        new SentenceViewModel(),
        new SentenceViewModel(),
        new SentenceViewModel()
        // new SentenceViewModel()
      ],
      normalizedList: [
        new SentenceViewModel(),
        new SentenceViewModel(),
        new SentenceViewModel()
        // new SentenceViewModel()
      ],
      fingerprint: new SentenceViewModel()
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.listenMessage();
    });
    let getid = setInterval(() => {
      let getBox = document.getElementsByClassName("sentenceMain")[0];
      if (getBox) {
        clearInterval(getid);
        let toolbar = document.querySelector(".lspan");
        let editorToolbarHeight = 0;
        if (toolbar !== null && toolbar !== undefined) {
          editorToolbarHeight = toolbar.offsetHeight;
        }
        this.fixEditorHeight(this.contentHeight, editorToolbarHeight);
      }
    }, 500);
  },
  beforeDestroy() {
    this.$messenger.clear();
  },
  computed: {
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    newSentence: {
      get() {
        return this.$store.state.editorControl.sentence;
      },
      set(val) {
        this.$store.state.editorControl.sentence = val;
      }
    },
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      let toolbar = document.querySelector(".lspan");
      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }
      this.fixEditorHeight(this.contentHeight, editorToolbarHeight);
    });
  },
  watch: {
    newSentence: {
      handler(val) {
        if (!this.wycShow) {
          if (val !== "") {
            this.getTranslate(this.newSentence);
            this.newSentence = "";
          }
        }
      }
    },
    contentHeight: {
      handler(val) {
        let toolbar = document.querySelector(".lspan");
        let editorToolbarHeight = 0;
        if (toolbar !== null && toolbar !== undefined) {
          editorToolbarHeight = toolbar.offsetHeight;
        }
        this.fixEditorHeight(val, editorToolbarHeight);
      }
    },
    showTxtType(newVal) {
      if (newVal) {
        localStorage.removeItem("sentenceCloseTxtType");
      } else {
        localStorage.setItem("sentenceCloseTxtType", 1);
      }
    },
    replace(newVal) {
      if (newVal) {
        localStorage.removeItem("sentenceCoreWordsReplace");
      } else {
        localStorage.setItem("sentenceCoreWordsReplace", 1);
      }
      if (this.showMiddle) {
        for (var i = 0; i < this.middleList.length; i++) {
          //中间重构有值
          if (this.middleList[i].result) {
            this.getNormalized(i + 1, this.middleList[i].result);
          }
        }
      } else {
        this.getFingerprint();
      }
    },
    showMiddle(newVal) {
      if (newVal) {
        localStorage.removeItem("sentenceShowMiddle");
        for (var i = 0; i < this.middleList.length; i++) {
          //中间重构有值
          if (this.middleList[i].result) {
            this.getNormalized(i + 1, this.middleList[i].result);
          }
        }
      } else {
        localStorage.setItem("sentenceShowMiddle", 1);
        this.getFingerprint();
      }
    }
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    listenMessage() {
      if (!this.wycShow) {
        if (this.newSentence !== "") {
          this.getTranslate(this.newSentence);
          this.newSentence = "";
        }
      }
      let that = this;
      //伪原创模式核心词
      this.$messenger.listen("sentencecoreword", e => {
        let getMsg = e.data;
        if (getMsg) {
          if (that.wycShow) {
            that.sentence = getMsg.source;
          }
          that.coreWords = getMsg.result.Data;
          if (that.wycShow) {
            that.getTranslate(that.sentence);
          }
        }
      });
      //编辑器模式核心词
      this.$messenger.listen("editcorewordextraction", e => {
        let getMsg = e.data;
        if (getMsg) {
          that.coreWords = getMsg.Data;
        }
      });
      //翻译接口数据
      this.$messenger.listen("getmiddle", e => {
        let getMsg = e.data;
        if (getMsg) {
          that.middleList[getMsg.Data.number - 1].loading = false;
          that.middleList[getMsg.Data.number - 1].like =
            getMsg.Data.result.like;
          that.middleList[getMsg.Data.number - 1].html =
            getMsg.Data.result.html;
          if (getMsg.ErrorCode > 0) {
            that.middleList[getMsg.Data.number - 1].result = getMsg.ErrorMess;
          } else {
            that.middleList[getMsg.Data.number - 1].result =
              getMsg.Data.result.result;
            // if (that.showMiddle) {
            //   that.getNormalized(getMsg.Data.number, getMsg.Data.result.result);
            // } else {
            //   if (getMsg.Data.number === 1) {
            //     that.getFingerprint();
            //   }
            // }
          }
        }
      });
      //整句智能原创的一键接口
      this.$messenger.listen("getnormalized", e => {
        let getMsg = e.data;
        if (getMsg) {
          if (that.showMiddle) {
            that.normalizedList[getMsg.Data.number - 1].loading = false;
            that.normalizedList[getMsg.Data.number - 1].like =
              getMsg.Data.result.like;
            that.normalizedList[getMsg.Data.number - 1].html =
              getMsg.Data.result.html;
            that.normalizedList[getMsg.Data.number - 1].result =
              getMsg.Data.result.result;
          } else {
            that.fingerprint.loading = false;
            that.fingerprint.like = getMsg.Data.result.like;
            that.fingerprint.html = getMsg.Data.result.html;
            if (getMsg.ErrorCode > 0) {
              that.fingerprint.result = getMsg.ErrorMess;
            } else {
              that.fingerprint.result = getMsg.Data.result.result;
            }
          }
        }
      });
      // window.addEventListener("message", function(e) {
      //   if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
      //     if (!e.data.isclose && e.data.btn === "sentencecoreword") {
      //       let getMsg = e.data.data;
      //       if (getMsg) {
      //         that.sentence = getMsg.source;
      //         that.coreWords = getMsg.result.Data;
      //         that.getTranslate(that.sentence);
      //       }
      //     }
      //     if (!e.data.isclose && e.data.btn === "aisentencecoreword") {
      //       let getMsg = e.data.data;
      //       if (getMsg) {
      //         that.coreWords = getMsg.Data;
      //       }
      //     }
      //     if (!e.data.isclose && e.data.btn === "getmiddle") {
      //       let getMsg = e.data.data;
      //       if (getMsg) {
      //         that.middleList[getMsg.number - 1].loading = false;
      //         that.middleList[getMsg.number - 1].like = getMsg.result.like;
      //         that.middleList[getMsg.number - 1].html = getMsg.result.html;
      //         that.middleList[getMsg.number - 1].result = getMsg.result.result;
      //         if (that.showMiddle) {
      //           that.getNormalized(getMsg.number, getMsg.result.result);
      //         } else {
      //           if (getMsg.number === 1) {
      //             that.getFingerprint();
      //           }
      //         }
      //       }
      //     }
      //     if (!e.data.isclose && e.data.btn === "getnormalized") {
      //       let getMsg = e.data.data;
      //       if (getMsg) {
      //         console.log(getMsg);
      //         if (that.showMiddle) {
      //           that.normalizedList[getMsg.number - 1].loading = false;
      //           that.normalizedList[getMsg.number - 1].like =
      //             getMsg.result.like;
      //           that.normalizedList[getMsg.number - 1].html =
      //             getMsg.result.html;
      //           that.normalizedList[getMsg.number - 1].result =
      //             getMsg.result.result;
      //         } else {
      //           that.fingerprint.loading = false;
      //           that.fingerprint.like = getMsg.result.like;
      //           that.fingerprint.html = getMsg.result.html;
      //           that.fingerprint.result = getMsg.result.result;
      //         }
      //       }
      //     }
      //   }
      // });
    },
    getFingerprint() {
      this.getNormalized(1, this.sentence);
    },
    use(getTxt) {
      if (this.wycShow) {
        let sendData = new SendPostData();
        sendData.btn = "usesentence";
        sendData.data = { txt: getTxt };
        this.sendNewMsg(sendData.btn, sendData.data);
      } else {
        let content = getTxt.replace(
          getTxt,
          '<span class="flicker">' + getTxt + "</span>"
        );
        tinymce.activeEditor.insertContent(content);
        tinymce.activeEditor.focus();

        // setTimeout(() => {
        //   let flicker = document.querySelector(".flicker");
        //   flicker.className = "";
        // }, 1000);
      }

      // this.SendMessage(sendData);
    },
    async getTranslate(getTxt) {
      let result = await this.APermission({ SysName: "wyctranslate" });
      if (result.errorCode > 0) {
        this.isUse = true;
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
        return;
      }
      if (result.data > 0 || result.data === -1) {
        for (let i = 0; i < this.middleList.length; i++) {
          this.middleList[i].loading = true;
          let sendData = new SendPostData();
          sendData.btn = "getmiddle";
          // if (!this.wycShow) {
          //   sendData.btn = "aigetmiddle";
          // }

          sendData.data = { type: "wyc" + (i + 1), number: i + 1, txt: getTxt };
          this.sendNewMsg(sendData.btn, sendData.data);
          // this.SendMessage(sendData);
        }
        if (!this.wycShow) {
          this.sentence = getTxt;
          this.getEditCoreWords(getTxt);
        }
      } else {
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
        // this.$message({
        //   message: "您的整句原创次数已用尽",
        //   type: "error",
        //   showClose: true
        // });
      }
    },
    getEditCoreWords(getTxt) {
      let sendData = new SendPostData();
      sendData.btn = "editcorewordextraction";
      sendData.data = {
        txt: getTxt
      };
      this.sendNewMsg(sendData.btn, sendData.data);
      // this.SendMessage(sendData);
    },
    getNormalized(num, getTxt) {
      if (this.showMiddle) {
        this.normalizedList[num - 1].loading = true;
      } else {
        this.fingerprint.loading = true;
      }
      let sendData = new SendPostData();
      sendData.btn = "getnormalized";
      let words = "";
      if (this.replace) {
        words = this.coreWords.map(m => m).join("|");
      }
      sendData.data = {
        corewords: words,
        source: this.sentence,
        number: num,
        txt: getTxt
      };
      this.sendNewMsg(sendData.btn, sendData.data);
      // this.SendMessage(sendData);
    },
    fixEditorHeight(newContentHeight, editorToolbarHeight = 0) {
      //console.log(newContentHeight);
      let editorStatusBarHeight = 200;
      // var editorStatusBarHeight =
      //   document.querySelector(".mce-statusbar").offsetHeight + 2;

      let realHeight =
        newContentHeight - editorToolbarHeight - editorStatusBarHeight;

      let getBox = document.getElementsByClassName("sentenceMain")[0];
      if (getBox) {
        getBox.style.height = realHeight + "px";
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
* {
  font-size: 12px;
}
.listTable {
  height: 300px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
}
/deep/.el-switch__core {
  border-color: #dcdfe6 !important;
  background-color: #dcdfe6 !important;
}
/deep/.el-switch.is-checked .el-switch__core {
  border-color: #13ce66 !important;
  background-color: #13ce66 !important;
}
.switch_top {
  margin-left: 5px;
  margin-top: -2px;
}
.sentence-body {
  /*width: 1180px;*/
  /*padding: 15px;*/
  padding: 10px 15px;
  font-size: 12px;
  display: flex;
  .sentenceMain {
    overflow: auto;
    overscroll-behavior-y: contain;
  }
}

.left-step {
  width: 3px;
  background-color: #eee;
  margin-right: 15px;
}

.step-down {
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 99;
  left: -27px;
  top: -1px;
  background: url(../../assets/image/wyc/down-gray.png) center center no-repeat
    white;
}

.sentence-body-part {
  padding: 5px;
  line-height: 24px;
  background-color: #efefef;
  margin-bottom: 12px;
  position: relative;

  label {
    font-weight: 600;
  }

  .tag {
    display: inline-block;
    line-height: 24px;
    background-color: #efefef;
    border-radius: 18px;
    padding: 0 10px;
    margin-right: 5px;
  }
}
.lspan {
  background-color: @boxback-color;
  line-height: 20px;
  padding: 7px 10px;
  border-radius: 5px;
}
.accordion-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  position: relative;

  label {
    font-weight: 600;
    margin-right: 8px;
  }

  .line {
    height: 1px;
    border-top: 1px dashed #c3c3c3;
    background-color: #eee;
    flex: 1;
  }
  .tag {
    display: inline-block;
    line-height: 20px;
    background-color: #efefef;
    border-radius: 18px;
    padding: 0 10px;
    margin-right: 5px;
  }
}
.group {
  position: relative;
  flex: 1;
  padding: 0 5px;
  height: 160px;

  .tabs-box {
    display: flex;
    line-height: 28px;
    font-size: 12px;

    .tabs {
      margin-right: 10px;
      display: table;
      box-shadow: none;
      width: auto;

      li {
        padding: 0 20px;
        /*border: solid 1px #e7e7e7;*/
        position: relative;
        bottom: -1px;
        border-bottom-style: none;
        background-color: white;
        border-radius: 4px 4px 0 0;
        border-bottom-style: none;
        border: 1px solid rgb(195, 201, 210);
        border-bottom: none;

        &.active {
          color: #333;
          border: solid 1px #8a8f97;
          border-bottom-style: none;
          z-index: 1;
        }
      }
    }
  }

  .input,
  input-div {
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #bbb;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ededed;
    }
  }

  .input {
    flex: 1;
    background-color: white;
    width: 100%;
    height: 120px;
    line-height: 24px !important;
    font-size: 12px !important;
    font: 13px/1.5 "Lantinghei SC", "Open Sans", Arial, "Hiragino Sans GB",
      "Microsoft YaHei", STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
    padding-bottom: 30px;
    border-top-left-radius: 0;
    border: 1px solid rgb(195, 201, 210);

    &.active {
      border-color: rgb(195, 201, 210) !important;
      color: #666;
    }

    &:hover,
    &:focus {
      border: solid 1px rgb(195, 201, 210);
    }
  }

  .input-div {
    background-color: white;
    display: inline-block;
    padding: 3px 5px;
    border: solid 1px #e7e7e7;
    border-radius: 2px;
    overflow: auto;
    overscroll-behavior-y: contain;
    border-top-left-radius: 0;
    .delete {
      background-color: #fbddda;
      text-decoration: line-through;
    }

    .insert {
      background-color: #d0e4c9;
      text-decoration: underline;
    }
  }

  .btn {
    border-radius: 4px;
    font-size: 12px;
    line-height: 24px;
    height: 24px;
    padding: 0 1em;
  }

  .similar {
    color: #3cb034;
    font-size: 12px;
    text-align: center;
    height: 25px;
    line-height: 25px;
    position: absolute;
    right: 6px;
    top: 123px;
    padding: 0 10px;
    background: #e7e7e7;
    border-top-left-radius: 4px;
  }

  &.group-flex {
    display: flex;
    height: auto;

    .tabs li {
      color: #333;
    }

    .input {
      color: #333;
    }

    > div {
      flex: 1;
      position: relative;

      .similar {
        right: 0;
      }
    }

    > .btn {
      height: 120px;
      margin-top: 30px;
      margin-left: 1%;
    }
  }
}
</style>

<style lang="less">
.delete {
  background-color: #fbddda;
  text-decoration: line-through;
}
.insert {
  background-color: #d0e4c9;
  text-decoration: underline;
}
</style>
